import HotelRoom from "../../hotels/types/HotelRoom";

export const getRoomImages = (hotelRoom: HotelRoom) => {
  const validImages = (hotelRoom.images || [])
    .filter(img => img.contentUrl !== null && img.contentUrl !== undefined);

  if (validImages.length > 0) {
    return validImages;
  }

  if (hotelRoom.principalImgContentUrl) {
    return [{
      id: hotelRoom.id,
      hotel: "",
      hotelId: hotelRoom.id as any,
      contentUrl: hotelRoom.principalImgContentUrl,
      name: "Principal"
    }];
  }

  return [];
};
